<template>
	<div class="contact__element contact__textarea">
		<label :for="`contact-${content._key}`"
					 class="textarea__label">
			{{ locale === 'en' ? content.title.en : content.title.jp }}
			<span v-if="content.isRequired" class="req">*</span>
		</label>
		<textarea :id="`contact-${content._key}`"
							class="textarea__input"
							:name="content._key"
							@input.once="$populatedInput"
							rows="10"
							cols="50"
							:required="!!content.isRequired" />
	</div>
</template>

<script setup>
	import { useI18n, useLocalePath } from '#imports'
	const { locale } = useI18n()
	const localePath = useLocalePath()
	const props = defineProps({
		content: Object
	})
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.contact__textarea {
	margin: 0 0 3rem 0;
	position: relative;
	width: 100%;
	&.populated, &:focus-within {
		label {
			background-color: v.$white;
			font-size: 0.9rem;
			padding: 0 0.5rem;
			transform: translateY(-0.75rem);
			transition: 0.3s;
		}
	}
	label {
		display: inline-block;
		left: 0.5rem;
		padding: 0.85rem;
		position: absolute;
		transition: 0.3s;
		.req {
			color: v.$red;
		}
	}
	input, textarea {
		border: 0.05rem solid v.$lightGrey;
		display: block;
		padding: 2rem 1rem 1rem 1rem;
		transition: 0.3s;
		width: 100%;
		&:focus {
			border: 0.05rem solid v.$teal;
			box-shadow: 0 0 7px -3px v.$teal;
			outline: none;
			transition: 0.3s;
		}
	}
}
</style>
